import React from 'react';
import { cn } from '../lib/utils';
import './SidebarUtilityButton.css';

export default function SidebarUtilityButton({ icon: Icon, children, className, ...props }) {
 return <button type="button" {...props} className={cn('office-sidebar-utility-button', className)}>
  {Icon && <Icon size={16} aria-hidden="true" />}<span>{children}</span>
 </button>;
}
